<template>
    <div id="contralor-controler-report" class="vs-con-loading__container">
        <!-- Select CARD -->
        <vs-card>
            <vs-row>
                <vs-col vs-w="8" vs-sm="12">
                    <label class="text-sm opacity-75">{{$t('periods')|capitalize}}</label>
                    <v-select
                         multiple
                        :options="periods"
                        v-model="params.periods"
                        :reduce="el => el.PeriodId"
                        label="PeriodLabel"
                        name="filterWeek"
                        class="mx-1"
                        
                    />
                </vs-col>
                <vs-col vs-w="2" vs-sm="6">
                    <vs-button class="w-full mt-5" @click="getReport" :disabled="params.periods.length==0" >{{$t('generate')|capitalize}}</vs-button>
                </vs-col>
                <vs-col vs-w="2" vs-sm="6">
                    <export-button :data="params" :url="'contralor/report/export/jbvkhl7ljgua4hjlfsa_asd4jfa_A_SD_d52'" :disabled="params.periods.length==0"  class="w-full mt-5 mx-1"/>
                </vs-col>
            </vs-row>
        </vs-card>
        <!-- END Select CARD -->
        <!-- Report Table -->
        <vs-card>
            <vs-row style="min-height:45vh">
                <report-table :dataTable="data"> </report-table>
            </vs-row>
        </vs-card>
        <!-- END Report Table -->
    </div>
</template>

<script>
import vSelect from 'vue-select'
import ReportTable from './components/ReportTable.vue'
import invoice from '@/http/requests/invoice'
import ExportButton from '@/views/components/ExportButton.vue'
import loading from '@/mixins/Loading'
export default {
    mixins:[loading],
    components:{
        vSelect,
        ReportTable,
        ExportButton
    },
    computed:{
        isLoading() {
            return this.loading.periods ||
                     this.loading.generate
        },
    },
    data() {
        return {
            periods:[],
            params:{
                periods:''
            },
            data:[],
            loading:{
                generate:false,
                periods:false
            }
        }
    },
    mounted() {
        this.init()
    },
    watch: {
        isLoading(val) {
            if (val) {
                this.openLoading(`contralor-controler-report`)
            } else {
                this.closeLoading(`contralor-controler-report`)
            }
        },
    },
    methods: {
        init(){
            this.getPeriods()
        },
        getReport(){
            this.loading.generate=true
            invoice.generateReport(this.params).then(res => {
                this.data=res.data.items
                this.loading.generate=false
            }).catch(err => {
                console.log(err)
                this.loading.generate=false
            })
        },
        getPeriods(){
            this.loading.periods=true
            invoice.getPeriodList().then(res => {
                this.periods = res.data.periodList
                this.loading.periods=false
            }).catch(err => {
                this.loading.periods=false
            })
        },
        exportCSV(){
            invoice.exportContralorReport(this.params)
        }
    },
}
</script>